import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { fromJS } from 'immutable';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import QueryString from 'query-string';
import Pluralize from 'pluralize';
import SweetAlert from 'sweetalert-react';
import withSizes from 'react-sizes';

import * as Utils from '../../utils/utils';
import * as Products from '../../utils/productHelpers';
import * as HtmlHelper from '../../utils/htmlHelper';
import * as ProductsActions from '../../actions/productsActions';
import ProductCard from '../../components/commons/cards/ProductCard';
import ProductDetailsPage from './ProductDetailsPage';
import CollapsableItem from '../../components/commons/collapsable-item/CollapsableItem';
import Loader from '../../components/commons/loader/loader';
import SortFiltersModal from '../../components/commons/modals/SortFiltersModal';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

class ProductListPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      products: [],
      isDescriptionPanelCollapsed: false,
      isSizePanelCollapsed: false,
      isLocationPanelCollapsed: false,
      limit: 20,
      skip: 0,
      isLoadMore: false,
      isParamsChanged: true,
      filters: DEFAULT_FILTERS,
      appliedFilters: {
        filterby_sizes: [],
        filterby_description: [],
        filterby_location: [],
        filterby_vintage: [],
        filterby_range: []
      },
      sortBy: 'name_asc',
      SortFiltersModalVisibility: false,
      scrollTop: 0,
      showAlert: false,
      swalParams: {
        title: ""
      },
      selectedFilters: [],
      value: { min: 0, max: 15 },
      maxValue: 0,
      minValue: 0,
    }

    this.getProductsTitle = this.getProductsTitle.bind(this);
    this.renderDescriptions = this.renderDescriptions.bind(this);
    this.renderSizes = this.renderSizes.bind(this);
    this.renderLocations = this.renderLocations.bind(this);
    this.renderVintage = this.renderVintage.bind(this);
    this.loadProducts = this.loadProducts.bind(this);
    this.exploreProduct = this.exploreProduct.bind(this);
    this.renderLoadMoreButton = this.renderLoadMoreButton.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.selectFilter = this.selectFilter.bind(this);
    this.onChangeSortOption = this.onChangeSortOption.bind(this);
    this.onApplySortAndFilters = this.onApplySortAndFilters.bind(this);
    this.renderSelectedFilters = this.renderSelectedFilters.bind(this);
    this.selectedFilterUnselect = this.selectedFilterUnselect.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.updateRangeFilter = this.updateRangeFilter.bind(this);
    this.addValuesToFilter = this.addValuesToFilter.bind(this);
    this.rangeFilterUnselect = this.rangeFilterUnselect.bind(this);
  }

  componentDidMount() {

    const { location } = this.props;
    const pageState = Utils.toJS(this.props.pageState);
    let params = QueryString.parse(location.search);
    console.log("OLD_PAGE_STATE", pageState);
    if (pageState && pageState.location && pageState.location.search == location.search) {

      if (this._sortBySelect) this._sortBySelect.value = pageState.sortBy;
      console.log("SortBy", this._sortBySelect, pageState.sortBy);
      this.setState(pageState, () => window.scrollTo(0, pageState.scrollTop));
    } else {
      this.loadProducts(params);
      this.loadFilters(params);
      window.scrollTo(0, 0);
    }

  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.filters &&  this.state.filters.filterby_range.items && this.state.filters.filterby_range.items[0]){
      if(this.state.filters.filterby_range.items[0] !== prevState.filters.filterby_range.items[0]){
        this.addValuesToFilter();
      } 
    }
  }

  componentWillReceiveProps(newProps) {

    const { location } = this.props;
    let params = QueryString.parse(newProps.location.search);
    if (location.search !== newProps.location.search) {
      this.setState({
        isParamsChanged: true,
        selectedFilters: [],
        appliedFilters: {
          filterby_sizes: [],
          filterby_description: [],
          filterby_location: [],
          filterby_range: [],
          filterby_vintage: [],
        }
      }, () => {
        this.loadProducts(params)
        this.loadFilters(params)
        window.scrollTo(0, 0)
      })
    } else {
      //this.setState({ isParamsChanged: false });
    }
  }

  render() {
    console.log('PRODUCT_LIST_PAGE_PROPS', this.props);
    console.log('PRODUCT_LIST_PAGE_STATE', this.state);

    const {
      products,
      isDescriptionPanelCollapsed,
      isSizePanelCollapsed,
      isLocationPanelCollapsed,
      isVintagePanintagePanelCollapsed,
      location,
      filters,
      filters:{filterby_range: {items:filterRange}},
      appliedFilters,
      SortFiltersModalVisibility,
      scrollTop,
      sortBy,
      filterSortAction,
      showAlert,
      swalParams,
      maxValue,
      minValue
    } = this.state;
    const { isMobile, loading } = this.props;
    return (
      <div className="page product-list">
        <div className="container content-container">
          <div className="row">
            <div className="col-md-4 col-lg-3 sidebar">
              {this.renderSelectedFilters()}
              <div className="price-range-heading">PRICE</div>
                <InputRange
                  draggableTrack
                  maxValue={filterRange[0] ? Math.round(filterRange[0].priceMax) : 1}
                  minValue={filterRange[0] ? Math.floor(filterRange[0].priceMin) : 0}
                  step={1}
                  formatLabel={value => `$${value}`}
                  value={this.state.value}
                  onChange={this.updateRangeFilter}
                  />
              <CollapsableItem title="Vintage" isCollapsed={isVintagePanintagePanelCollapsed} renderBody={this.renderVintage} onToggleBody={() => this.setState({
                isVintagePanintagePanelCollapsed: !isVintagePanintagePanelCollapsed
              })} />
              <CollapsableItem title="Type" isCollapsed={isDescriptionPanelCollapsed} renderBody={this.renderDescriptions} onToggleBody={() => this.setState({
                isDescriptionPanelCollapsed: !isDescriptionPanelCollapsed
              })} />
              <CollapsableItem title="Location" isCollapsed={isLocationPanelCollapsed} renderBody={this.renderLocations} onToggleBody={() => this.setState({
                isLocationPanelCollapsed: !isLocationPanelCollapsed
              })} />
              <CollapsableItem title="Size" isCollapsed={isSizePanelCollapsed} renderBody={this.renderSizes} onToggleBody={() => this.setState({
                isSizePanelCollapsed: !isSizePanelCollapsed
              })} />
            </div>
            <div className="col-md-8 col-lg-9">
              <div className="row">
                <div className="col-md-8 left-container">
                  <h1 className="page-title">{this.getProductsTitle().toUpperCase()}</h1>
                  <div className="page-description">{`We found ${products.length} results`}</div>
                </div>
                <div className="col-md-4 right-container">
                  <div className="sort-options-container">
                    <span>Sort By:</span>
                    <div className="select-wrap">
                      <select onChange={this.onChangeSortOption} defaultValue={sortBy} ref={(el) => this._sortBySelect = el}>
                        <option value="name_asc">{'Name: A to Z'}</option>
                        <option value="name_desc">{'Name: Z to A'}</option>
                        <option value="price_asc">{'Price: Low to High'}</option>
                        <option value="price_desc">{'Price: High to Low'}</option>
                      </select>
                    </div>
                  </div>

                </div>
              </div>
              {isMobile ? (
                <div className="row product-cards-row-mobile">
                  {products && products.length > 0
                    ? Utils.chunkArrayInGroups(products, 2).map((productsInRow, idx) => {
                      return (
                        <div className="product-cards-mobile" key={`products_row_${idx}`}>
                          <div className="product-card-container">
                            <ProductCard data={productsInRow[0]} onSelectProduct={() => this.exploreProduct(productsInRow[0])} onAddToCart={() => this.addToCart(productsInRow[0])} noOutOfStock={true}
                            checkAvailiblityAlert={() => this.checkAvailiblityAlert()}/>
                          </div>
                          {productsInRow.length == 2 ? (
                            <div className="product-card-container">
                              <ProductCard data={productsInRow[1]} onSelectProduct={() => this.exploreProduct(productsInRow[1])} onAddToCart={() => this.addToCart(productsInRow[1])} noOutOfStock={true}
                              checkAvailiblityAlert={() => this.checkAvailiblityAlert()}/>
                            </div>
                          ) : null}
                        </div>
                      )
                    })
                    : (
                      <div className="no-products-message">No products to show</div>
                    )
                  }
                </div>
              ) : (
                <div className="row product-cards">
                  {products && products.length > 0
                    ? products.map((product, idx) => {
                      return (
                        <div className="col-md-6 col-lg-4 product-card-container" key={`product_${idx}`}>
                          <ProductCard data={product} onSelectProduct={() => this.exploreProduct(product)} onAddToCart={() => this.addToCart(product)} noOutOfStock={true}
                          checkAvailiblityAlert={() => this.checkAvailiblityAlert()}/>
                        </div>
                      )
                    })
                    : (
                      <div className="no-products-message">No products to show</div>
                    )
                  }
                </div>
              )}
              {this.renderLoadMoreButton()}
            </div>

          </div>
        </div>
        <div className="mobile-filter-sort-bar">
          <div className="filters-button" onClick={() => {
            HtmlHelper.hideBodyScroll((scrollTop) => {
              this.setState({ SortFiltersModalVisibility: true, filterSortAction: 'filter', scrollTop: scrollTop });
            })
          }}>Filters</div>
          <div className="sort-button" onClick={() => {
            HtmlHelper.hideBodyScroll((scrollTop) => {
              this.setState({ SortFiltersModalVisibility: true, filterSortAction: 'sort', scrollTop: scrollTop })
            })
          }}>Sort</div>
        </div>
        <Loader visibility={loading} />
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={() => this.setState({ showAlert: false })} show={showAlert} {...swalParams} onConfirm={() => this.setState({ showAlert: false })} />
        <SortFiltersModal visibility={SortFiltersModalVisibility} actionMode={filterSortAction} filters={filters} sortBy={sortBy} appliedFilters={appliedFilters} onSelectFilter={this.selectFilter} onApply={(filters, sort) => {
          this.setState({
            SortFiltersModalVisibility: false
          }, () => {
            this.onApplySortAndFilters(filters, sort);
            HtmlHelper.showBodyScroll(0);
          })
        }} onClose={() => {
          HtmlHelper.showBodyScroll(scrollTop);
          this.setState({ SortFiltersModalVisibility: false });
        }} onClearFilters={() => {
          HtmlHelper.showBodyScroll(0);
          this.setState({
            SortFiltersModalVisibility: false
          }, () => this.clearFilters());
        }} />
      </div>
    )
  }

  renderSelectedFilters() {
    const { selectedFilters } = this.state;

    return selectedFilters.length
      ? (
        <div className="selected-filters">
          <h4>You've selected filters</h4>
          {_.map(selectedFilters, (filter) => {
            if (filter.type === 'filterby_range') {
              let range = filter._id.split('-');
              return (
                <div className="filter--item" key={filter._id}>
                  {`Price: $${range[0]}-$${range[1]}`}
                <button onClick={() => this.rangeFilterUnselect(filter)}>x</button>
              </div>
              );
            } else {
              return (
                <div className="filter--item" key={filter._id}>
                  {filter._id}
                  <button onClick={() => this.selectedFilterUnselect(filter)}>x</button>
                </div>
              );
            }    
          })
          }
          <a className="clear-filters-link" href="javascript:void(0)" onClick={() => this.clearFilters()}>Clear all Filters</a>
        </div>
      )
      : (null);
  }

  selectedFilterUnselect(filter) {
    console.log(filter);

    this.selectFilter(filter.type, filter);
    //
    // if(filter.type == 'size'){
    //   this.selectFilter('filterby_sizes', filter)
    // }else{
    //   this.selectFilter('filterby_description', filter)
    // }
  }

  rangeFilterUnselect(filter) {
    this.addValuesToFilter();
    this.selectFilter(filter.type, filter);
  }

  addValuesToFilter() {
    let maxValue=0,
        minValue = 0,
        range = {...this.state.value};
    if(this.state.filters && this.state.filters.filterby_range && this.state.filters.filterby_range.items && 
      this.state.filters.filterby_range.items[0] && this.state.filters.filterby_range.items[0]){
        maxValue = Math.round(this.state.filters.filterby_range.items[0].priceMax);
        minValue = Math.floor(this.state.filters.filterby_range.items[0].priceMin);
      }
      range.min = minValue;
      range.max = maxValue;
      this.setState({
                  value: range, 
                  maxValue:maxValue,
                  minValue: minValue});
  } 

  clearFilters() {

    const { sortBy } = this.state;
    this.setState({
      appliedFilters: {
        filterby_sizes: [],
        filterby_description: [],
        filterby_location: [],
        filterby_vintage: [],
        filterby_range: []
      },
      selectedFilters: [],
      sortBy: sortBy,
      products: [],
      skip: 0
    }, () => {
      this.loadProducts();
    });
    this.addValuesToFilter();
  }

  renderDeliveryAddress() {
    return (
      <div className="filter-item-text">
        <ul>
          <li>828 s. Main Street,</li>
          <li>Los Angeles, CA 90014</li>
        </ul>
      </div>
    );
  }

  renderSizes() {

    const { filters, appliedFilters } = this.state;
    let filterCount = filters && filters.filterby_sizes
      ? filters.filterby_sizes.items.length
      : 0;

    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_sizes.items.map((filter, idx) => {
                let isSelected = appliedFilters.filterby_sizes.indexOf(filter._id) != -1
                //console.log("IS SELECTED", filter._id, appliedFilters.filterby_sizes.indexOf(filter._id));
                return filter._id && filter._id.trim()
                  ? (
                    <li key={`filterby_sizes_${filter._id}`} className={`option ${isSelected
                      ? 'active'
                      : ''}`} onClick={() => this.selectFilter('filterby_sizes', filter)}>{`${filter._id} (${filter.count})`}</li>
                  )
                  : null
              })
              }
            </ul>
          )
          : null
        }
      </div>
    )
  }

  renderVintage() {
    const { filters, appliedFilters } = this.state;
    let filterCount = filters && filters.filterby_vintage
      ? filters.filterby_vintage.items.length
      : 0;
    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_vintage.items.map((filter, idx) => {
                  let isSelected = appliedFilters.filterby_vintage && appliedFilters.filterby_vintage.indexOf(filter._id) != -1
                  return filter._id && filter._id.trim()
                    ? (
                      <li key={`filterby_vintage_${filter._id}`} className={`option ${isSelected
                        ? 'active'
                        : ''}`} onClick={() => this.selectFilter('filterby_vintage', filter)}>{`${filter._id} (${filter.count})`}</li>
                    )
                    : null
              })
              }
            </ul>
          )
          : null
        }
      </div>
    )
  }


  renderDescriptions() {

    const { filters, appliedFilters } = this.state;
    let filterCount = filters && filters.filterby_description
      ? filters.filterby_description.items.length
      : 0;

    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_description.items.map((filter, idx) => {

                let isSelected = appliedFilters.filterby_description.indexOf(filter._id) != -1;
                return filter._id && filter._id.trim()
                  ? (
                    <li key={`filterby_description_${filter._id}`} className={`option ${isSelected
                      ? 'active'
                      : ''}`} onClick={() => this.selectFilter('filterby_description', filter)}>{`${filter._id} (${filter.count})`}</li>
                  )
                  : null
              })
              }
            </ul>
          )
          : null
        }
      </div>
    )
  }

  renderLocations() {

    const { filters, appliedFilters } = this.state;
    let filterCount = filters && filters.filterby_location
      ? filters.filterby_location.items.length
      : 0;

    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_location.items.map((filter, idx) => {

                let isSelected = appliedFilters.filterby_location.indexOf(filter._id) != -1;
                return filter._id && filter._id.trim()
                  ? (
                    <li key={`filterby_location_${filter._id}`} className={`option ${isSelected
                      ? 'active'
                      : ''}`} onClick={() => this.selectFilter('filterby_location', filter)}>{`${filter._id} (${filter.count})`}</li>
                  )
                  : null
              })
              }
            </ul>
          )
          : null
        }
      </div>
    )
  }

  updateRangeFilter(value) {
    this.setState({ value: value });
    const max = value.max;
    const min = value.min;
    this.selectFilter('filterby_range', { _id: `${min}-${max}` });
  }

  onChangeSortOption(e) {

    let selectedSortOption = e.target.value;

    this.setState({
      products: [],
      sortBy: selectedSortOption,
      skip: 0
    }, () => {
      this.loadProducts();
    });

    console.log("Selected sort option", selectedSortOption);
  }

  onApplySortAndFilters(filters, sortBy) {

    const { products, skip } = this.state;
    let isFilters = (filters.filterby_sizes.length > 0) || (filters.filterby_description.length > 0) || (filters.filterby_location.length > 0) || (filters.filterby_vintage > 0) || (filters.filterby_range.length > 0);
    this.setState({
      appliedFilters: filters,
      sortBy: sortBy,
      products: isFilters
        ? []
        : products,
      skip: isFilters
        ? 0
        : skip,
      isParamsChanged: true
    }, () => {
      this.loadProducts();
    });
  }

  selectFilter(type, filter) {
    const { products, skip, sortBy } = this.state;
    let modifiedFilters = this.state.appliedFilters;
    let selectedFilters = this.state.selectedFilters;
    let modifiedFilter = Object.assign({}, filter);
    modifiedFilter['type'] = type;
    let indexOfFilter = selectedFilters.findIndex(x => x._id == filter._id);
    console.log("Selected FIlter Index", indexOfFilter);
    
    if(type === DEFAULT_FILTERS.filterby_range.id) {
      selectedFilters.forEach(function (value, index){
        if(value.type === type){
          selectedFilters.splice(index, 1);
        }
      })  
      modifiedFilters[type] = []; 
    }

      if (indexOfFilter < 0) {
        selectedFilters.push(modifiedFilter);
      } else {
        selectedFilters.splice(indexOfFilter, 1);
      }
  
      if (!modifiedFilters[type])
        modifiedFilters[type] = [];
      if (modifiedFilters[type].indexOf(filter._id) < 0) {
        modifiedFilters[type].push(filter._id);
      } else {
        modifiedFilters[type].splice(modifiedFilters[type].indexOf(filter._id), 1);
      }
    this.setState({ selectedFilters })
    this.onApplySortAndFilters(modifiedFilters, sortBy);
  }

  renderLoadMoreButton() {

    const { isLoadMore } = this.state;

    return isLoadMore
      ? (
        <div className="load-more-button" onClick={() => this.loadMore()}>Load More</div>
      )
      : null;
  }

  getProductsTitle() {
    const { location } = this.props;
    let params = QueryString.parse(location.search);
    if (params.department)
      return params.department
    else if (params.category)
      return params.category
    else if (params.type)
      return params.type
    else
      return 'All Products'
  }

  loadProducts(params, options) {

    const { location } = this.props;
    const { limit, products, isParamsChanged, appliedFilters, sortBy } = this.state;
    params = params
      ? params
      : QueryString.parse(location.search);
    let skip = options && options.skip
      ? options.skip
      : this.state.skip;
    if (isParamsChanged)
      skip = 0;

    params.limit = limit;
    params.skip = skip;
    params.filters = appliedFilters;
    params.sortOptions = buildSortByOptions(sortBy);

    if (params && params.department && params.department === 'WINES') {

      params.featured = 'false';
      this.props.dispatch(ProductsActions.getAllWines(params, response => {
        if (response.status) {
          // id is required
          const impressions = response.data.map(p => ({
              id: p._id,
              name: p.Description,
              ...p
          }));
          window.dataLayer.push({ event: 'list', ecommerce: { impressions } });

          this.setState({
            products: isParamsChanged
              ? response.data
              : products.concat(response.data),
            skip: skip,
            isLoadMore: response.data && (response.data.length == limit)
          });
        } else {
          this.setState({
            showAlert: true,
            swalParams: {
              title: "Failed to get wines, please try again later!",
              type: "error",
              showConfirmButton: false
            }
          })
          setTimeout(() => this.setState({ showAlert: false }), 2000);
        }
      }));
    } else {
      this.props.dispatch(ProductsActions.getProducts(params, response => {
        if (response.status) {
          // id is required
          const impressions = response.data.map(p => ({
              id: p._id,
              name: p.Description,
              ...p
          }));
          window.dataLayer.push({ event: 'list', ecommerce: { impressions } });

          this.setState({
            products: isParamsChanged
              ? response.data
              : products.concat(response.data),
            skip: skip,
            isLoadMore: response.data && (response.data.length == limit)
          })
        } else {
          this.setState({
            showAlert: true,
            swalParams: {
              title: "Failed to load products, please try again later!",
              type: "error",
              showConfirmButton: false
            }
          })
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        }
      }))
    }
  }

  loadMore() {
    const { limit } = this.state;
    const { location } = this.props;
    let params = QueryString.parse(location.search);
    let skip = this.state.skip + limit;
    this.setState({
      isParamsChanged: false
    }, () => {
      this.loadProducts(params, { skip });
    })
  }

  loadFilters(params) {
    let filterOptions = {};
    if (params && (params.category || params.department)) {
      filterOptions.name = params.category
        ? params.category
        : params.department;
      filterOptions.type = params.category
        ? 'category'
        : 'department';
      this.props.dispatch(ProductsActions.getProductFilters(filterOptions, response => {
        console.log("FILTERS_GET_RESPONSE", response);
        if (response.status) {
          this.setState({ filters: response.data }, () => {
            this.addValuesToFilter();
          })
        } else {
          this.setState({
            showAlert: true,
            swalParams: {
              title: "Something went wrong, please try again later!",
              type: "error",
              showConfirmButton: false
            }
          })
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        }

      }))
    } else
      this.setState({ filters: DEFAULT_FILTERS })

  }

  exploreProduct(product) {
    const { location } = this.props;

    let state = this.state;
    state.location = location;
    state.scrollTop = window.pageYOffset;
    console.log("PAGE_STATE", state);
    this.props.dispatch(ProductsActions.setListPageState(fromJS(state)));
    this.props.history.push(`/products/${product._id}`);
  }

  addToCart(product) {

    Utils.addToCart(product)
      .then(() => {
        this.setState({
          isItemAddedToCart: true,
          showAlert: true,
          swalParams: {
            title: "Product added to cart successfully.",
            type: "success",
            showConfirmButton: false,
          }
        })
        setTimeout(() => this.setState({ showAlert: false }), 1500);
      })
      .catch(err => {
        console.error(err);
        this.setState({
          showAlert: true,
          swalParams: {
            title: err.title,
            type: "warning",
            showCloseButton: true
          }
        });
      });
  }

  checkAvailiblityAlert() {
   
    this.setState({
      showAlert: true,
      swalParams: {
        title: "Address not selected",
        type: "error",
        showConfirmButton: false
      }
    });
    
}

}

function buildSortByOptions(selectedSortOption) {

  let sortOption = {};
  switch (selectedSortOption) {

    case 'name_asc':
    default:
      sortOption.Description = 1
      break;
    case 'name_desc':
      sortOption.Description = -1
      break;
    case 'price_asc':
      sortOption.PriceB = 1
      break;
    case 'price_desc':
      sortOption.PriceB = -1
  }
  return sortOption;
}

const DEFAULT_FILTERS = {
  filterby_sizes: {
    id: 'filterby_sizes',
    name: 'Sizes',
    index: 'Size',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_description: {
    id: 'filterby_description',
    name: 'Descriptions',
    index: 'Sub Description 2',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_location: {
    id: 'filterby_location',
    name: 'Locations',
    index: 'Sub Description 3',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_vintage: {
    id: 'filterby_vintage',
    name: 'Vintage',
    index: 'Vintage',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_range: {
    id: 'filterby_range',
    name: 'Range',
    index: 'PriceB',
    itemType: 'Range',
    items: [],
    products: {}
  }
}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 768,
    isTablet: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    pageState: state.getIn(['products', 'listPageState']),
    loading: state.getIn(['products', 'loading']),
    products: state.getIn(['products', 'products'])
  };
})(ProductListPage))



// WEBPACK FOOTER //
// ./src/containers/products/ProductListPage.js